import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import DragHandleSvg from './DragHandleSvg'
import HelpIcon from './HelpIcon'
import createNewLineAfterBlock from './createNewLineAfterBlock'
import SettingsIcon from './SettingsIcon'

const styles = {
  container: {
    position: 'relative',
    backgroundColor: '#f4f5f6',
    padding: 20,
    marginRight: 32,
    marginTop: 6,
    marginBottom: 6,
  },
  dragHandleContainer: {
    position: 'absolute',
    top: 0,
    right: -46,
    bottom: 0,
    width: 46,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'move',
  },
  dragHandle: {
    margin: '0 auto',
  },
  selected: {
    //outline: '2px dashed green',
    background: `linear-gradient(to left, #909AAA4F, #7A808C4F)`,
  },
  selectCheckbox: {
    position: 'relative',
    left: -15,
    appearance: 'none',
  },
  selectCheckboxContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  input: {
    height: 40,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 2,
    border: '1px solid #dee1e5',
    backgroundColor: 'white',
    width: 358,
    boxSizing: 'border-box',
    color: '#858585',
    appearance: 'none',
  },
}

class ControlWrapperUnstyled extends Component {

  state = {}

  componentWillReceiveProps = (newProps) => {
    if ('placeholder' in newProps)
      this.setState({ value: newProps.placeholder })
  }

  componentDidMount = () => {
    document.body.addEventListener('click', this.onBodyClick)
    document.body.addEventListener('keyup', this.onKeyUp)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('click', this.onBodyClick)
    document.body.removeEventListener('keyup', this.onKeyUp)
  }

  onBodyClick = (e) => {
    // Don't do anything if not already selected
    if (!this.props.selected)
      return
    var node = e.target
    while (node != document.body && node.parentNode) {
      if (node == this.container_ )
        return
      node = node.parentNode
    };
    if (this.props.shouldCloseOnClick && this.props.shouldCloseOnClick(e) != true)
      return
    this.props.onUpdate({ selected: false })
    if (this.props.onBlur)
      this.props.onBlur()
  }

  onDragHandleClick = (e) => {
    const { onDragStart, controlKey } = this.props
    onDragStart(e, [controlKey])
  }

  onSelect = () => {
    this.props.onUpdate({ selected: true })
    if (this.props.onSelect)
      this.props.onSelect()
  }

  onCheckboxSelect = () => {
    const { onUpdate, checkboxSelected } = this.props
    onUpdate({ checkboxSelected: !checkboxSelected })
  }

  onClick = (e) => {
    // This is so the click won't bubble up and then focus on the draft-js-editor
    e.stopPropagation()
    e.preventDefault()
  }

  onKeyUp = (e) => {
    const { selected } = this.props
    if (!selected) return
    // This means we have an input or something selected so we don't want
    // to create a new line
    if (e.target != document.body) return
    if (e.keyCode == 8) {
      this.props.onUpdate({ selected: false })
      return this.props.onControlDelete()
    }
    if (e.keyCode != 13) return
    var { editorState, onEditorStateChange, controlKey } = this.props
    onEditorStateChange(createNewLineAfterBlock(editorState, controlKey))
  }

  render = () => {
    const {
      placeholder,
      classes,
      showCheckbox,
      checkboxSelected,
      header,
      helpText,
      dragging,
      children,
      icon,
      selected,
      ...otherProps } = this.props

    return <div
      className={classNames({
        [classes.container]: true,
        [classes.selected]: selected || checkboxSelected,
      })}
      onMouseDown={this.onSelect}
      ref={el => this.container_ = el}
      onClick={this.onClick}
      onMouseUp={this.onClick}
    >
      <div className={classes.dragHandleContainer}
        onMouseDown={this.onDragHandleClick}
      >
        <DragHandleSvg className={classes.dragHandle} />
      </div>
      {(selected || showCheckbox) ?
        <div className={classes.selectCheckboxContainer}>
          <Checkbox
            className={classes.selectCheckbox}
            value={checkboxSelected}
            onClick={this.onCheckboxSelect}
          />
        </div> :
        null}
      {children}
    </div>
  }
}

const ControlWrapper = injectStyles(styles)(ControlWrapperUnstyled)

export default ControlWrapper

class ControlWrapperExtendedUnstyled extends Component {

  state = {
    header: this.props.header,
  }

  onHelpTextChange = (helpText) => {
    this.props.onUpdate({ helpText })
  }

  shouldCloseOnClick = (e) => {
    var node = e.target
    // If the help text isn't open then carry on and close
    if (!this.hoverContainer_) return true
    var hoverContainer = ReactDOM.findDOMNode(this.hoverContainer_)
    while (node != document.body && node.parentNode) {
      if (node == hoverContainer)
        return false
      node = node.parentNode
    };
    return true
  }

  onHeaderChange = (e) => this.setState({ header: e.target.value })

  onHeaderBlur = () => {
    const { header } = this.state
    this.props.onUpdate({ header })
  }

  render = () => {
    const {
      icon,
      classes,
      helpText,
      dragging,
      children,
      selected,
      blockType,
      ...otherProps,
    } = this.props
    const { header } = this.state

    return <ControlWrapper
      {...otherProps}
      selected={selected}
      shouldCloseOnClick={this.shouldCloseOnClick}
    >
      <div className={classes.iconContainer}>
        {icon}
      </div>
      <input
        value={header}
        placeholder="Header"
        className={classes.header}
        onChange={this.onHeaderChange}
        onBlur={this.onHeaderBlur}
      />
      <HelpIcon
        className={classes.helpIcon}
        helpText={helpText}
        onHelpTextChange={this.onHelpTextChange}
        disabled={dragging || !selected}
        hoverContainerRef={el => this.hoverContainer_ = el}
      />
      <SettingsIcon
        onUpdate={this.props.onUpdate}
        type={blockType}
        className={classes.settingsIcon}
      />
      {children}
    </ControlWrapper>
  }
}

export const ControlWrapperExtended = injectStyles({
  header: {
    backgroundColor: 'transparent',
    border: 'none',
    display: 'inline-block',
    marginLeft: 24,
    fontSize: 13,
    color: '#4F4F4F',
    marginBottom: 20,
    appearance: 'none',
    width: 270,
  },
  helpIcon: {
    position: 'absolute',
    top: 22,
    right: 70,
  },
  settingsIcon: {
    position: 'absolute',
    top: 24,
    right: 40,
    cursor: 'pointer',
  },
  iconContainer: {
    display: 'inline-block',
    width: 10,
  },
})(ControlWrapperExtendedUnstyled)


export const Checkbox = injectStyles({
  checkbox: {
    width: 26,
    height: 26,
    borderRadius: 2,
    border: '1px solid #dee1e6',
    boxSizing: 'border-box',
    appearance: 'none',
    //'&:checked': {
    //  backgroundColor: 'red',
    //},
  },
  container: {
    position: 'relative',
  },
  checkIcon: {
    width: 16,
    height: 16,
    position: 'absolute',
    top: 8,
    left: 8,
    pointerEvents: 'none',
    background: `linear-gradient(to left, #FC4A1A80, #F7B73380)`,
  },
})(
  ({ value, classes, className, ...otherProps }) =>
    <div className={classNames(classes.container, className)}>
      <input
        {...otherProps}
        type="checkbox"
        checked={value}
        className={classes.checkbox}
      />
      {value ? <div className={classes.checkIcon} /> : null}
    </div>
)


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/ControlWrapper.js